export default __webpack_public_path__ + "static/media/28.b6e0386b.gif";